import useSharedMailLink from "./hooks/useSharedMailLink";

import { memo } from "react";

/**
 * Gets params from the URL and doing request,
 * then redirecting (from response) to the shared mail (gallery).
 */
const ShareMailRedirectPage = () => {
  useSharedMailLink();

  return null;
};

export default memo(ShareMailRedirectPage);
